/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */
import * as References from './ReviewsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#generateTitle
 */
export const GENERATE_TITLE_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_generateTitle';
export const GENERATE_TITLE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GENERATE_TITLE_QUERY_FIELD_NAME,
  args: ['type', 'entityName', 'answers', 'ratings'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.generateTitleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getSummary';
export const GET_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getStatsBatch
 */
export const GET_STATS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getStatsBatch';
export const GET_STATS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'type'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getStatsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getEditability
 */
export const GET_EDITABILITY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getEditability';
export const GET_EDITABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EDITABILITY_QUERY_FIELD_NAME,
  args: ['reviewId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getEditabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getThemes
 */
export const GET_THEMES_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getThemes';
export const GET_THEMES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_THEMES_QUERY_FIELD_NAME,
  args: ['entityId', 'type', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getThemesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviews
 */
export const SEARCH_REVIEWS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_searchReviews';
export const SEARCH_REVIEWS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_REVIEWS_QUERY_FIELD_NAME,
  args: ['search', 'language', 'sortFields', 'entityId', 'reviewTypes', 'reviewTypesEnums', 'overallRating', 'reviewerPortalId', 'reviewerUserId', 'employeeSizes', 'industries', 'tagFilters', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.searchReviewsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#searchReviewsLegacy
 */
export const SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_searchReviewsLegacy';
export const SEARCH_REVIEWS_LEGACY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_REVIEWS_LEGACY_QUERY_FIELD_NAME,
  args: ['search', 'language', 'sortFields', 'entityId', 'reviewTypes', 'reviewTypesEnums', 'overallRating', 'reviewerPortalId', 'reviewerUserId', 'employeeSizes', 'industries', 'tagFilters', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.searchReviewsLegacyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#checkReviewability
 */
export const CHECK_REVIEWABILITY_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_checkReviewability';
export const CHECK_REVIEWABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_REVIEWABILITY_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewTypeName'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.checkReviewabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStats
 */
export const GET_OVERALL_STATS_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStats';
export const GET_OVERALL_STATS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OVERALL_STATS_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewTypeName'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getOverallStatsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getOverallStatsBatch
 */
export const GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getOverallStatsBatch';
export const GET_OVERALL_STATS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_OVERALL_STATS_BATCH_QUERY_FIELD_NAME,
  args: ['entityIds', 'reviewTypeName'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getOverallStatsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc#getPrivateFeedback
 */
export const GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME = 'com_hubspot_reviews_rpc_ReviewsRpc_getPrivateFeedback';
export const GET_PRIVATE_FEEDBACK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIVATE_FEEDBACK_QUERY_FIELD_NAME,
  args: ['entityId', 'reviewTypeName', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getPrivateFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});